import React from 'react';
import cx from 'clsx';
import styles from '../GameDetailsTop.module.scss';
import { GameTileProps } from '../../../modular-grid/types';
import { isEqual } from 'src/utils/lodash-alternatives';

interface GameDetailsSingleImagePropTypes {
  image: GameTileProps['image'];
  title: string;
}

const GameDetailsSingleImage: React.FC<GameDetailsSingleImagePropTypes> = React.memo(
  ({ image, title }) => {
    if (!image) return null;
    return (
      <div
        data-testid="game-details-header-image-simple"
        className={cx(styles.image, styles.imageSmall)}
      >
        <img
          data-testid="game-details-header-image-simple-tag"
          alt={title}
          className={styles.imageTag}
          src={image.source.normal}
        />
      </div>
    );
  },
  (
    prevProps: GameDetailsSingleImagePropTypes,
    nextProps: GameDetailsSingleImagePropTypes
  ) => isEqual(prevProps, nextProps)
);

export default GameDetailsSingleImage;
